var icon = require('vue-svgicon')
icon.register({
  'ks-icon-double-chevron': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M88.48 63.79L64 39.31 39.52 63.79 32 56.21l32-32 32 32zM88.48 103.79L64 79.31l-24.48 24.48L32 96.21l32-32 32 32z"/>'
  }
})
